<template>
  <div class="personal-detail-page">
    <div v-if="loading" class="text-center py-5">
      <CSpinner color="primary" />
    </div>
    <div v-else-if="error" class="alert alert-danger my-4">
      {{ error }}
      <div class="mt-3">
        <button class="btn btn-outline-primary" @click="goBack">{{ text('กลับไปหน้ารายการ', 'Back to reports') }}</button>
      </div>
    </div>
    <div v-else-if="ticket">
      <UReportDetail
        :report="ticket"
        @close="goBack"
        @refresh="fetchTicket"
      />
    </div>
  </div>
</template>

<script>
import Service from '@/service/api';
import UReportDetail from '@/pages/user/UReportDetail.vue';

export default {
  name: 'StudentAffairsPersonalDetail',
  components: {
    UReportDetail,
  },
  props: {
    ticketId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      ticket: null,
      loading: true,
      error: null,
    };
  },
  computed: {
    lang() {
      return this.$store?.state?.locale?.lang || 'th';
    },
  },
  watch: {
    ticketId: {
      immediate: true,
      handler(val) {
        if (val) {
          this.fetchTicket();
        }
      },
    },
  },
  methods: {
    text(th, en) {
      return this.lang === 'en' ? en : th;
    },
    async fetchTicket() {
      this.loading = true;
      this.error = null;
      try {
        const response = await Service.ticket('get', null, {
          urlAppend: `/${encodeURIComponent(this.ticketId)}`,
        });
        if (response.data?.success && response.data?.data) {
          this.ticket = response.data.data;
        } else {
          this.error = response.data?.message || this.text('ไม่พบข้อมูลใบแจ้งซ่อม', 'Ticket not found');
        }
      } catch (err) {
        console.error('Failed to load personal ticket detail:', err);
        this.error = err.response?.data?.message || err.message || this.text('เกิดข้อผิดพลาดในการโหลดข้อมูล', 'Failed to load ticket');
      } finally {
        this.loading = false;
      }
    },
    goBack() {
      this.$router.push('/student-affairs/my-reports');
    },
  },
};
</script>

<style scoped>
.personal-detail-page {
  width: 100%;
  padding-bottom: 30px;
}
</style>
